// extracted by mini-css-extract-plugin
export default {"spinner":"bKOkd","error":"OKTQe"};